import { c as _c } from "react/compiler-runtime";
import { IcoForbid40 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import type { IdDocImageErrorType } from '../../types';
import PromptWithGuidelines from '../prompt-with-guidelines';
type ErrorProps = {
  sideName?: string;
  errors: IdDocImageErrorType[];
  docName?: string;
  countryName?: string;
};
const ErrorComponent = t0 => {
  const $ = _c(23);
  const {
    errors,
    sideName,
    docName,
    countryName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] !== errors) {
    t2 = errors.some(_temp);
    $[1] = errors;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isClassifierRejection = t2;
  let t3;
  if ($[3] !== isClassifierRejection || $[4] !== t) {
    t3 = isClassifierRejection ? t(_temp2) : undefined;
    $[3] = isClassifierRejection;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== countryName || $[7] !== docName || $[8] !== errors || $[9] !== sideName || $[10] !== t) {
    let t5;
    if ($[12] !== countryName || $[13] !== docName || $[14] !== sideName || $[15] !== t) {
      t5 = error_0 => t($_0 => $_0.description[error_0.errorType], {
        documentType: docName,
        side: sideName,
        countryName,
        errorInfo: error_0.errorInfo
      });
      $[12] = countryName;
      $[13] = docName;
      $[14] = sideName;
      $[15] = t;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = errors.map(t5);
    $[6] = countryName;
    $[7] = docName;
    $[8] = errors;
    $[9] = sideName;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[17] !== t) {
    t5 = t(_temp3);
    $[17] = t;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <PromptWithGuidelines icon={IcoForbid40} description={t3} guidelines={t4} title={t5} variant="error" />;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default ErrorComponent;
function _temp(error) {
  return error.errorType === "custom_document_not_recognized";
}
function _temp2($) {
  return $["retry-hint"];
}
function _temp3($_1) {
  return $_1.title;
}